// extracted by mini-css-extract-plugin
module.exports = {"space":"LayoutMobile_space__xBxc8","appbar":"LayoutMobile_appbar__1_Pid","btn-color":"LayoutMobile_btn-color__xmnU_","nav-btm":"LayoutMobile_nav-btm__1_VWE"};